import { render, staticRenderFns } from "./commerceBranchSelect.vue?vue&type=template&id=f0803130&scoped=true&"
import script from "./commerceBranchSelect.vue?vue&type=script&lang=ts&"
export * from "./commerceBranchSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0803130",
  null
  
)

export default component.exports